import RegularListContainer from './RegularListContainer';
export default RegularListContainer;
